import $ from 'jquery';

import { Foundation } from 'libs/foundation';

import App from 'libs/app';

// convenience function to test the DOM for existence of a selector
const testDom = (selector) => (document.querySelectorAll(selector).length > 0);

// convenience function to add a Foundation plugin and reinit Foundation (with the new plugin)
const initFoundationPlugin = (module, pluginName) => {
    Foundation.plugin(module[pluginName], pluginName);
    $(document).foundation();
};

// lazy loading modules
App.registerUiComponent('common-lazy-modules', () => {
    // lazy load Foundation plugins
    if (testDom('[data-reveal]')) {
        import('foundation-sites/js/foundation.reveal')
            .then((module) => initFoundationPlugin(module, 'Reveal'));
    }
    if (testDom('[data-equalizer]')) {
        import('foundation-sites/js/foundation.equalizer')
            .then((module) => initFoundationPlugin(module, 'Equalizer'));
    }

    // lazy load stage box
    if (testDom('#stage')) {
        import('modules/tud.stage');
    }

    // lazy load svg button handling on start page
    if (testDom('#intro-start-box')) {
        import('modules/tud.lottie')
            .then((module) => initFoundationPlugin(module, 'Lottie'));
    }

    // lazy load captcha ajax reload
    if (testDom('.captcha')) {
        import('modules/tud.captcha');
    }

    // lazy load customized Foundation accordion
    if (testDom('[data-accordion]')) {
        import('modules/tud.accordion')
            .then((module) => initFoundationPlugin(module, 'Accordion'));
    }

    // lazy load gallery foundation plugin
    if (testDom('[data-gallery]')) {
        import('modules/tud.gallery')
            .then((module) => initFoundationPlugin(module, 'Gallery'));
    }

    // lazy load audio player foundation plugin
    if (testDom('[data-audio-player]')) {
        import('modules/tud.audioplayer')
            .then((module) => initFoundationPlugin(module, 'AudioPlayer'));
    }

    // lazy load iFrame resizer
    if (testDom('.includebox iframe, .html-box iframe')) {
        import('modules/tud.iframe');
    }

    // lazy load TUD batch (ajax for pagination widgets)
    if (testDom('[data-tudbatch]')) {
        import('modules/tud.batch')
            .then((module) => initFoundationPlugin(module, 'TUDBatch'));
    }

    // lazy load PloneFormGen waiting notice JS
    if (testDom('.pfg-form form')) {
        import('modules/tud.pfgWaitNotice');
    }

    // lazy load TP unit selector Foundation plugin
    if (testDom('[data-tpunit-selector]')) {
        import('authenticated/tud.TPUnitSelectorWidget')
            .then((module) => initFoundationPlugin(module, 'TPUnitSelector'));
    }

    // lazy DSC form updater script
    if (testDom('body.portaltype-event #fieldset-export')) {
        import('authenticated/tud.eventdsc');
    }

    // lazy load sinsStart JS
    if (testDom('#sins-keyword-search')) {
        import('modules/tud.sinsStart');
        import('modules/tud.toggleButton');
    }

    // lazy load sync for zopra edit and sins start
    if (testDom('[data-sync]')) {
        import('modules/tud.sync')
            .then((module) => initFoundationPlugin(module, 'Sync'));
    }

    // lazy load tud.tableToDropdown
    if (testDom('table[data-table-to-dropdown]')) {
        import('modules/tud.tableToDropdown');
    }

    // lazy load vis-timeline
    if (testDom('#timeline')) {
        import('vis-timeline').then((visModule) => {
            const event = new Event('VisTimelineLoaded');
            event.vis = visModule;
            document.dispatchEvent(event);
        });
    }

    if (testDom('#plone-browser')) {
        import('authenticated/tud.plonefinderPatches');
    }

    // lazy load tud.xmasSpecial
    // only activate this on christmas days
    /* const minDate = new Date((new Date()).getFullYear(), 11, 23);
    const maxDate = new Date((new Date()).getFullYear(), 11, 27);
    const now = new Date();
    if (now < minDate || now > maxDate) {
        import('modules/tud.xmasSpecial');
    } */

    // init Foundation Plugins as the DOM is ready now
    $(document).foundation();
});

// export lazy loading modules that should be accessible from "outside"
const lazyExports = {};

// export tud.autocomplete lazy loader as "TudAutocomplete"
lazyExports.TudAutocomplete = (...args) => {
    import('modules/tud.autocomplete').then((AutocompleteModule) => {
        const Autocomplete = AutocompleteModule.default;
        // eslint-disable-next-line no-new
        new Autocomplete(...args);
    });
};

export default lazyExports;
